/**
 * Standard layout constraints for consistent page widths across the application
 */
export const LAYOUT_CONSTRAINTS = {
  /** Maximum page width: 1600px */
  MAX_WIDTH: "max-w-[1600px]",
  /** Minimum page width: 1200px */
  MIN_WIDTH: "xl:min-w-[1200px]",
  /** Combined width constraints for centered content containers */
  CONTAINER_WIDTH: "max-w-[1600px] xl:min-w-[1200px] w-full",
} as const;

/**
 * Smart Briefs modal dimensions (based on Figma 1440x960 viewport with 1372x893 modal)
 */
export const BRIEF_MODAL_DIMENSIONS = {
  /** Modal width: 95.3vw (1372/1440) */
  WIDTH: "w-[95.3vw]",
  /** Modal height: 93vh with max constraint */
  HEIGHT: "h-[93vw] max-h-[93vh]",
  /** Combined dimensions for brief modals */
  SIZE: "w-[95.3vw] h-[93vw] max-h-[93vh]",
} as const;
